var map = {
	"./lay1.png": 8406,
	"./lay2.png": 29,
	"./lay3.png": 3732,
	"./lay4.png": 5387,
	"./lay5.png": 7522,
	"./lay6.png": 8233,
	"./lay7.png": 7056,
	"./lay8.png": 7639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9454;